import React, { useState } from "react";
import NavBar from "./common/NavBar";
import { DashboardRoutes } from "../routes";
import BackButton from "./BackButton";

const Dashboard = () => {
  const [avatarurl, setAvatarurl] = useState(localStorage.getItem("avatarurl"));
  return (
    <div  className="min-h-[95vh]">
      <NavBar avatarurl={avatarurl} />
      <div className="sm:ml-8"><BackButton ></BackButton> </div>
      <main>
        <DashboardRoutes />
      </main>
    </div>
  );
};

export default Dashboard;
